import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const DIAS_SEMANA = ['Lunes', 'Martes', 'Miércoles', 'Jueves', 'Viernes', 'Sábado', 'Domingo'];

const MoveModal = ({ isOpen, trabajo, weekDates = [], onClose, onMove }) => {
  const [selectedDate, setSelectedDate] = useState('');
  const [moveType, setMoveType] = useState('solo'); // 'solo' | 'recurrencia'
  const [saving, setSaving] = useState(false);

  if (!isOpen || !trabajo) return null;

  const isRecurrente = trabajo?.tipo_trabajo === 'RECURRENTE';

  const handleMove = async () => {
    if (!selectedDate) return;
    setSaving(true);
    try {
      await onMove(trabajo?.id, selectedDate, moveType);
      onClose();
    } catch (err) {
      console.error('[MoveModal.handleMove]', err);
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center p-4" style={{ background: 'rgba(0,0,0,0.7)' }}>
      <div className="w-full max-w-sm rounded-2xl border border-white/10 overflow-hidden" style={{ background: '#111111' }}>
        <div className="flex items-center justify-between px-5 py-4 border-b border-white/8">
          <h2 className="font-oranienbaum font-bold text-white text-lg">Mover trabajo</h2>
          <button onClick={onClose} className="text-white/40 hover:text-white/70 transition-colors">
            <Icon name="X" size={18} />
          </button>
        </div>

        <div className="p-5 space-y-4">
          <div className="text-white/60 text-sm font-oranienbaum">
            <span className="text-white font-semibold">{trabajo?.cliente?.nombre}</span> · {trabajo?.cantidad_piezas} piezas
          </div>

          {/* Day selector */}
          <div>
            <label className="block text-white/70 text-sm font-oranienbaum mb-2">Mover a</label>
            <div className="grid grid-cols-4 gap-1.5">
              {weekDates?.map((d, i) => (
                <button
                  key={d}
                  onClick={() => setSelectedDate(d)}
                  className={`py-2 rounded-lg text-xs font-oranienbaum border transition-colors ${
                    selectedDate === d
                      ? 'bg-[#D6EF4E]/15 border-[#D6EF4E]/40 text-[#D6EF4E]'
                      : 'border-white/10 text-white/50 hover:border-white/25'
                  }`}
                >
                  {DIAS_SEMANA?.[i]?.slice(0, 3)}
                </button>
              ))}
            </div>
          </div>

          {/* Recurrence warning */}
          {isRecurrente && (
            <div className="space-y-2">
              <p className="text-yellow-400/80 text-xs font-oranienbaum">Este trabajo es recurrente. ¿Qué quieres hacer?</p>
              <div className="space-y-1.5">
                <button
                  onClick={() => setMoveType('solo')}
                  className={`w-full text-left p-3 rounded-lg border text-sm font-oranienbaum transition-colors ${
                    moveType === 'solo' ? 'border-[#D6EF4E]/40 bg-[#D6EF4E]/8 text-[#D6EF4E]' : 'border-white/10 text-white/60 hover:border-white/20'
                  }`}
                >
                  Mover solo esta semana
                </button>
                <button
                  onClick={() => setMoveType('recurrencia')}
                  className={`w-full text-left p-3 rounded-lg border text-sm font-oranienbaum transition-colors ${
                    moveType === 'recurrencia' ? 'border-orange-400/40 bg-orange-400/8 text-orange-400' : 'border-white/10 text-white/60 hover:border-white/20'
                  }`}
                >
                  Cambiar recurrencia futura
                </button>
              </div>
            </div>
          )}

          <div className="flex gap-3 pt-1">
            <button
              onClick={onClose}
              className="flex-1 py-3 rounded-xl border border-white/10 text-white/60 font-oranienbaum hover:bg-white/5 transition-colors"
            >
              Cancelar
            </button>
            <button
              onClick={handleMove}
              disabled={saving || !selectedDate}
              className="flex-1 py-3 rounded-xl font-oranienbaum font-bold text-black transition-all disabled:opacity-50"
              style={{ background: '#D6EF4E' }}
            >
              {saving ? '...' : 'Mover'}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MoveModal;
